<bca-start-upload
    *ngIf="(dialogState$ | async) === ImageDialogState.CHOOSE"
    class="dialog-body"
    [isUploading]="isUploading$ | async"
    (cancel)="onCancel()"
    (fileSelected)="onFileSelected($event)">
</bca-start-upload>
<bca-result-upload
    *ngIf="(dialogState$ | async) === ImageDialogState.RESULT"
    class="dialog-body"
    [image]="faceImage$ | async"
    [metrics]="faceImageMetrics$ | async"
    (checked)="onChecked($event)"
    (choose)="onChoose()"
    (save)="onSave()">
</bca-result-upload>
